import React, { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../HomeNavbar/Navbar";
import { Box, Typography, Button, Grid } from "@mui/material";
import { Typewriter } from "react-simple-typewriter";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import bannerImg1 from "../../assets/img/bannerImg1.png";
import logo2 from "../../assets/img/logo2.jpg";
import CustomerOrderModal from "../../components/modal/CustomerOrderModal";
import ServiceBanner from "../../components/banner/ServiceBanner";
import FeedbackBanner from "../../components/banner/FeedbackBanner";
import About from "../../components/banner/About";
import WhyUs from "../../components/banner/WhyUs";
import Appbanner from "../../components/banner/Appbanner";
import Footer from "../../components/banner/Footer";
import { useTheme } from "@mui/material/styles";
const Home = () => {
  const theme = useTheme();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // Function to handle form submission
  const handleSubmitOrder = (orderData) => {
    console.log("Order Submitted: ", orderData);
    // Handle order submission logic here
  };

  return (
    <Box sx={{ position: "relative", minHeight: { xs: "120vh", md: "150vh" } }}>
      {/* Navbar */}
      <Navbar />

      {/* SVG Ellipse positioned in top-right corner */}
      <Box
        component="div"
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <svg
          width="226"
          height="218"
          viewBox="0 0 226 218"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="236.5" cy="16.5" rx="236.5" ry="201.5" fill="#C7E7FF" />
        </svg>
      </Box>

      {/* Main Content using Grid */}
      <Grid
        container
        spacing={2} // Spacing between grid items
        justifyContent="center"
        alignItems="center"
        sx={{
          height: { xs: "calc(90vh - 64px)", md: "calc(80vh - 64px)" },
          px: { xs: 2, md: 8 },
          py: { xs: 4, md: 8 },
        }}
      >
        {/* Left blank space (0.5 columns) */}
        <Grid item xs={false} md={0.5}></Grid>

        {/* Left section (5.5 columns) */}
        <Grid
          item
          xs={12}
          md={5.5}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: { xs: "center", md: "flex-start" },
            textAlign: { xs: "center", md: "left" },
            gap: "1rem",
          }}
        >
          {/* Container for Title and Subtitle with minimal gap */}
          <motion.div
            initial={{ opacity: 0, x: -150 }} // Start from the left
            animate={{ opacity: 1, x: 0 }} // Move to original position
            transition={{ duration: 1.5 }} // Adjust the duration
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "0rem",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: "#114C78",
                  fontWeight: "bold",
                }}
              >
                India’s No 1
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  color: "#FF893A",
                  fontWeight: 600,
                  paddingTop: "20px",
                }}
              >
                <Typewriter
                  words={["Water Delivery Platform", "Welcomes You"]}
                  loop={true}
                  cursor
                  cursorStyle="..."
                  typeSpeed={80}
                  deleteSpeed={50}
                  delaySpeed={3000}
                />
              </Typography>
            </Box>
          </motion.div>

          {/* Additional text sections container with no space between items */}
          <motion.div
            initial={{ opacity: 0, x: -150 }} // Start from the left
            animate={{ opacity: 1, x: 0 }} // Move to original position
            transition={{ duration: 1.8, delay: 0.5 }} // Delay for staggered effect
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0,
              }}
            >
              {[
                "Welcome to the Drips Water Delivery Platform !",
                "Stay hydrated with our seamless water delivery services all over India.",
              ].map((text, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    color: "#888585",
                  }}
                >
                  {text}
                </Typography>
              ))}
              {/* New motivational quote */}
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.primary.light,
                  fontWeight: "500",
                  mt: 1,
                }}
              >
                "Be a water saver, not a water waster."
              </Typography>
            </Box>
          </motion.div>

          {/* Start Now Button */}
          <motion.div
            initial={{ opacity: 0, x: -150 }} // Start from the left
            animate={{ opacity: 1, x: 0 }} // Move to original position
            transition={{ duration: 2, delay: 1 }} // Delay for staggered effect
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#36AB5D",
                padding: "12px",
                borderRadius: "25px",
                color: "#fff",
                mt: 2,
                textTransform: "capitalize",
                width: "10rem",
                "&:hover": {
                  backgroundColor: "#2C8F4A",
                },
              }}
              onClick={handleOpenModal}
            >
              Order Now
            </Button>
          </motion.div>
        </Grid>

        {/* Right section with an image (5.5 columns) */}
        <Grid
          item
          xs={12}
          md={5.5}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <motion.img
            src={bannerImg1}
            alt="Sample"
            initial={{ opacity: 0, x: 150 }} // Starting from the right
            animate={{ opacity: 1, x: 0 }} // Fading in and moving to the original position
            transition={{ duration: 3 }} // Adjust duration as needed
            style={{
              width: "70%",
              height: "70%",
            }}
          />
        </Grid>

        {/* Right blank space (0.5 columns) */}
        <Grid item xs={false} md={0.5}></Grid>
      </Grid>

      {/* SVG and Services Section */}
      <Box
        component="div"
        sx={{
          flexShrink: 0, // Prevent shrinking
          position: "relative",
          zIndex: -1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Box
          component="div"
          sx={{
            display: { xs: "none", sm: "block" }, // Hides the SVG on extra small screens and shows on small and larger
          }}
        >
          <svg
            width="320"
            height="403"
            viewBox="0 0 320 403"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="83.5"
              cy="201.5"
              rx="236.5"
              ry="201.5"
              fill="#C7E7FF"
            />
          </svg>
        </Box>

        <Typography
          variant="h3"
          sx={{
            textAlign: "left",
            color: theme.palette.secondary.main,
            fontWeight: "600",
            mb: 4,
            width: "60%",
          }}
        >
          What We{" "}
          <span style={{ color: theme.palette.primary.light }}>Offer</span>
        </Typography>
      </Box>

      {/* Modal for placing customer order */}
      <CustomerOrderModal
        open={isModalOpen} // Modal open state
        handleClose={handleCloseModal} // Function to close modal
        handleSubmit={handleSubmitOrder} // Function to handle order submission
      />
      <Box>
        <Box id="services-section">
          <ServiceBanner />
        </Box>
        <FeedbackBanner />
        <Box id="about-section">
          <About />
        </Box>
        <WhyUs />
      </Box>
      <Box id="AppBanner" sx={{marginTop:"5vh"}}>
        <Appbanner/>
        </Box>    
      <Box>
        <Footer />
      </Box>

      {/* Floating WhatsApp Button */}
      <FloatingWhatsApp
        phoneNumber="+919601117624"
        accountName="Drips water"
        avatar={logo2}
        statusMessage="Typically replies within minutes"
        chatMessage="Hello! How can we assist you today?"
        allowEsc
        allowClickAway
      />
    </Box>
  );
};

export default Home;
